/**
 * Created by Yangxunwu on 2018/6/21.
 */
const getters = {

	token: state => state.user.token,
	phone: state => state.user.phone,
	name: state => state.user.name,
	email: state => state.user.email,
	finishRegister: state => state.user.finishRegister,
	userType: state => state.user.type,

	headerFields: state => state.salary.headerFields,
    recordData: state => state.salary.recordData,
	recordDataTotal: state => state.salary.recordDataTotal,

}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js